module.exports = __webpack_public_path__ + "img/2_255.83fd8d7d.png";